import React, { useState } from "react";
import PayoutCard from "../../global/PayoutCard";

import { ArrowLeftRight, Wallet2, WalletMinimal } from "lucide-react";
import { Calendar } from "phosphor-react";
import ApexChart from "../../tools/ApexChart";
import BarChart from "../../tools/BarChart";
import Dropdown from "../../global/Dropdown";

export default function Analytics() {
  const colorClasses = {
    blue: {
      text: "text-blue-600",
      icon_bg: "bg-blue-600/20",
      progress_bg: "bg-blue-600",
    },
    green: {
      text: "text-green-600",
      icon_bg: "bg-green-600/20",
      progress_bg: "bg-green-600",
    },
    red: {
      text: "text-red-600",
      icon_bg: "bg-red-600/20",
      progress_bg: "bg-red-600",
    },
    yellow: {
      text: "text-yellow-500",
      icon_bg: "bg-yellow-500/20",
      progress_bg: "bg-yellow-500",
    },
    purple: {
      text: "text-purple-600",
      icon_bg: "bg-purple-600/20",
      progress_bg: "bg-purple-600",
    },
  };
  
  const [activeTab, setActiveTab] = useState(3);
  const type = [
    { id: 1, label: "Last 7 Days" },
    { id: 2, label: "Last 15 Days" },
    { id: 3, label: "Last 30 Days" },
  ];
  const handleTabClick = (id) => {
    setActiveTab(id);
  };
  const [filterByApp, setFilterByApp] = useState("");
  const [filterByGateway, setFilterByGateway] = useState("");

  const filterByAppOption = [
    { label: "App 1", value: "id_1" },
    { label: "App 2", value: "id_2" },
    { label: "App 3", value: "id_3" },
  ];
  const filterByGatewayOption = [
    { label: "Cashfree", value: "id_1" },
    { label: "XOXOday", value: "id_2" },
    { label: "GiftCode", value: "id_3" },
  ];
  return (
    <div className="space-y-4">
      <div className="flex  items-center justify-between">
        {/* time section */}
        <div className="flex flex-col space-y-2">
          {/* time tabs */}
          <h1 className="text-xs font-medium text-slate-800 dark:text-slate-200">
            Time Period
          </h1>

          <div
            className="flex space-x-2 py-2 p-2 bg-slate-300/25 dark:bg-gray-700/30 backdrop-blur-xl rounded-lg   
              "
          >
            {type.map((tab) => (
              <button
                key={tab.id}
                onClick={() => handleTabClick(tab.id)}
                className={` text-[12px] font-semibold  py-2
           p-1 rounded-md transition-all duration-200 transform
           ${
             tab.id === activeTab
               ? "bg-blue-500 dark:bg-blue-500 text-white px-2"
               : "border-transparent cursor-pointer text-slate-800 dark:text-slate-300 "
           }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
        {/* filter */}
        <div className="flex items-center space-x-6">
         
          <Dropdown
            label="Filter by App"
            value={filterByApp}
            options={filterByAppOption}
            onChange={setFilterByApp}
            placeholder="All Apps"
            className="text-sm"
          />
          <Dropdown
            label="Filter by Gateway"
            value={filterByGateway}
            options={filterByGatewayOption}
            onChange={setFilterByGateway}
            placeholder="All Gateways"
            className="text-sm"
          />
          
        </div>
      </div>
      {/* Payout cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
        <PayoutCard
          title={"Total Payout"}
          amount={2000000}
          icon={WalletMinimal}
          color={colorClasses.blue}
          time={"3 days period"}
        />
        <PayoutCard
          title={"Avg Daily Payout"}
          amount={2400}
          icon={Calendar}
          color={colorClasses.green}
          time={"Per Day Average"}
        />
        <PayoutCard
          title={"Total Transactions"}
          amount={2000000}
          icon={ArrowLeftRight}
          color={colorClasses.purple}
          time={"All Apps-All Gateways"}
        />
      </div>
      <div className="pt-4">
        <ApexChart
          title={"Daily Payout Trend"}
          name={"Payout Amount"}
          data={[30, 60, 45]}
          categories={["nov 1", "nov 2", "nov 3"]}
          type={"area"}
        />
      </div>
      <div className="pt-4">
        <BarChart
          title={" Payout by App for Cashfree"}
          subtitle={83000}
          name={"Payout Amount"}
          data={[83000]}
          categories={["App 1"]}
        />
      </div>
    </div>
  );
}
